import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import styles from 'pages/services/trade-finance/TradeFinance.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Services/TradeFinance/components/SectionHeader'));
const SectionAbout = dynamic(() => import('sections/Services/TradeFinance/components/SectionAbout'));
const SectionSolutions = dynamic(() => import('sections/Services/TradeFinance/components/SectionSolutions'));
const SectionWorkflow = dynamic(() => import('sections/Services/TradeFinance/components/SectionWorkflow'));
const SectionChoose = dynamic(() => import('sections/Services/TradeFinance/components/SectionChoose'));
const SectionContact = dynamic(() => import('sections/Services/TradeFinance/components/SectionContact'));
const SectionDisclaimer = dynamic(() => import('sections/Services/TradeFinance/components/SectionDisclaimer'));

export default function TradeFinance() {
  return (
    <div className={cn('trade-finance')}>
      <SectionHeader />
      <SectionAbout />
      <SectionSolutions />
      <SectionWorkflow />
      <SectionChoose />
      <SectionContact />
      <SectionDisclaimer />
    </div>
  );
}

export const getStaticProps = async () => {
  return {
    props: {
      title: 'Trade Finance Services by DF Alliance | DF Alliance',
      description: 'Discover DF Alliance\'s Trade Finance services to optimize your international trade operations and ensure financial security in global freight transactions.',
      path: '/services/trade-finance',
    },
  };
};

TradeFinance.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
